"use client";

import { useEffect, useState } from "react";
import { useTranslations } from "next-intl";
import Layout from "@/Web/Layout/Layout";
import TFButton from "@/Web/Components/TFButton/TFButton";
import { DOMAIN_HUB } from "@/config/domains";

export default function NotFound() {
  const t = useTranslations("notFound");
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <Layout>
      <div className="min-h-[60vh] flex items-center justify-center py-16">
        <div className="text-center space-y-8 max-w-2xl mx-auto px-4">
          {/* Анимированное число 404 */}
          <div className="relative">
            <div
              className={`text-6xl md:text-[8rem] font-bold text-transparent bg-clip-text bg-gradient-to-br from-black via-black/80 to-black/60 leading-none transition-all duration-1000 ${
                mounted ? "opacity-100" : "opacity-0"
              }`}
              style={{
                textShadow: "0 0 40px rgba(0, 0, 0, 0.1)",
              }}
            >
              404
            </div>
            {/* Декоративные элементы */}
            <div className="absolute -top-4 -left-4 w-24 h-24 border-2 border-black/20 rounded-full opacity-20 animate-pulse"></div>
            <div className="absolute -bottom-4 -right-4 w-32 h-32 border-2 border-black/20 rounded-full opacity-20 animate-pulse delay-300"></div>
          </div>

          {/* Заголовок */}
          <div
            className={`space-y-4 transition-all duration-1000 delay-200 ${
              mounted ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
            }`}
          >
            <h1 className="text-4xl md:text-5xl font-semibold text-black">
              {t("title")}
            </h1>
            <p className="text-lg md:text-xl text-black/70 max-w-xl mx-auto leading-relaxed">
              {t("description")}
            </p>
          </div>

          {/* Кнопки действий */}
          <div
            className={`flex flex-col sm:flex-row gap-4 justify-center items-center pt-4 transition-all duration-1000 delay-400 ${
              mounted ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
            }`}
          >
            <TFButton
              title={t("goHome")}
              href="/"
              type="primary"
              className="!flex-none"
            />
            <TFButton
              title={t("goToHub")}
              href={`//${DOMAIN_HUB}`}
              noLang={true}
              type="default"
              className="!flex-none"
            />
          </div>
        </div>
      </div>
    </Layout>
  );
}
